module.exports = __webpack_public_path__ + "img/logo.254b46d0.png";